import '@/frontend/assets/css/all.css';
import '@/frontend/assets/css/jquery-ui.css';
import MainHeader from '@/common/components/MainHeader';
import MainFooter from '@/common/components/MainFooter';
import { mapGetters } from 'vuex';
import '@/frontend/modals/BuyWorkModal';
import { useRouter } from "vue-router";
import { onMounted } from "vue";
export default {
  name: 'App',
  components: {
    MainHeader,
    MainFooter
  },

  setup() {
    const router = useRouter();
    onMounted(() => {
      router.afterEach((from, to) => {
        if (from.href !== to.href) {
          window.ym && window.ym(91319525, 'hit', to.href, {
            referer: from.href,
            title: document.title
          });
        }
      });
    });
  },

  computed: { ...mapGetters(['modalSettings'])
  },

  created() {
    this.$router.afterEach(() => window.scrollTo(0, 0));
  }

};